import React, { PropsWithChildren } from 'react';
import { classNames } from '../utils/classNames';

// A small chip that the user clicks to turn one option on or off. It has the anatomy of Tag.
// On: white, blue ring, blue text. Off: gray, struck text. The caller owns the state:
// onToggle receives the next value. The optional count shows after the label ("CORPORATE · 3").
type Props = {
	pressed: boolean,
	onToggle: (pressed: boolean) => void,
	count?: number,
	disabled?: boolean,
	title?: string,
};

const ToggleChip: React.FunctionComponent<PropsWithChildren<Props>> = ({
	children,
	pressed,
	onToggle,
	count,
	disabled = false,
	title,
}) => {
	return <button
		type="button"
		aria-pressed={pressed}
		disabled={disabled}
		title={title}
		onClick={() => onToggle(!pressed)}
		className={classNames(
			'inline-flex items-center whitespace-nowrap rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600',
			pressed ? 'bg-white text-blue-700 ring-blue-600' : 'bg-gray-100 text-gray-400 ring-gray-200 line-through',
			disabled ? 'cursor-not-allowed opacity-50' : (pressed ? 'hover:bg-blue-50' : 'hover:text-gray-500'),
		)}>
		{children}
		{count !== undefined ? <span className="ml-1">· {count}</span> : null}
	</button>;
};

export default ToggleChip;
